import bundledLanguages from '@locales/list_languages.json';
import { Language } from './i18n.model';

// Seeded from the bundle so resolution never runs against an empty list until
// setSupportedLanguages swaps in the fetched catalog.
let supportedLanguages: string[] = (bundledLanguages as { value: string }[]).map(
  language => language.value
);

export const setSupportedLanguages = (codes: string[]): void => {
  if (codes.length > 0) {
    supportedLanguages = codes;
  }
};

// Accept both underscore (fr_FR) and BCP-47 hyphenated (fr-FR) tags: i18n.language
// is detector-driven and can arrive hyphenated from the browser / Intl.
export const resolveSupported = (code?: string): string => {
  const normalized = code?.replaceAll('-', '_');
  return normalized && supportedLanguages.includes(normalized) ? normalized : Language.en_US;
};

// en_US -> en-US: Intl expects BCP-47 hyphenated tags.
export const toBcp47 = (code: string): string => code.replaceAll('_', '-');

// en_US / en-US -> en: OneTrust's geo rule is configured with base ISO 639-1
// codes, so passing a full culture tag (de-DE) throws "doesn't exist for the
// geo rule". Send only the base language to Optanon.changeLanguage.
export const toBaseLanguage = (code: string): string =>
  code.replaceAll('_', '-').split('-')[0].toLowerCase();
